import React, { useState, useEffect } from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useQuizHotSpotContext } from '../../../../context/QuizHotSpotContext';
import { useQuizContext } from '../../../../context/QuizContext';
import { HotSpotData } from '../../../../types/quiz';
import { QuizContainer } from '../../QuizContainer';
import { P } from '@osmosis/react-ui/components/Text';
import HotSpotArea from './HotSpotArea';
import HotSpotCursor from './HotSpotCursor';
import QuizSubmitButtons from '../../QuizSubmitButtons';
import { CorrectBanner, SkipQuizButton } from '../utils';
import { useHotspotImageSize } from './useHotspotImageSize';
import { Image } from 'rebass';

enum cursorType {
  default,
  correct,
  incorrect,
}

/**
 * Https://elsevier.atlassian.net/browse/OSMS-683.
 */
const HotSpot = () => {
  const { currentItem, isAnswered, submitAnswer } = useQuizContext();
  const { isActive, handleClick, checkIsCorrect, setIsActive } =
    useQuizHotSpotContext();
  const [cursor, setCursor] = useState(cursorType.default);
  useEffect(() => {
    setIsActive(false);
    setCursor(cursorType.default);
  }, [(currentItem?.data as HotSpotData).directions]);

  useEffect(() => {
    if (checkIsCorrect() && isAnswered) {
      setCursor(cursorType.correct);
    }
    if (!checkIsCorrect() && isAnswered) {
      setCursor(cursorType.incorrect);
    }
  }, [checkIsCorrect, isAnswered]);

  const width = useHotspotImageSize(
    (currentItem?.data as HotSpotData).question,
  );

  return (
    <Flex flexDirection="column">
      <QuizContainer>
        <P
          fontSize={16}
          color="gray50"
          fontWeight={400}
          textAlign="justify"
          dangerouslySetInnerHTML={{
            __html: (currentItem?.data as HotSpotData).directions,
          }}
        />

        <Box
          onClick={!isAnswered ? (e) => handleClick(e) : undefined}
          data-testid="hot-spot-container"
          alignSelf="center"
          sx={{ position: 'relative', width }}
        >
          <Image
            width={'100%'}
            alt="hotspot image"
            src={(currentItem?.data as HotSpotData).question}
          />

          <HotSpotArea isAnswered={isAnswered} />
          {isActive && <HotSpotCursor cursor={cursor} />}
        </Box>
        {isAnswered && <CorrectBanner isCorrectAnswer={checkIsCorrect()} />}
      </QuizContainer>
      {isActive && !isAnswered && (
        <QuizSubmitButtons submit={(c) => submitAnswer(c, checkIsCorrect())} />
      )}
      <SkipQuizButton />
    </Flex>
  );
};

export default HotSpot;
